import React, { PropsWithChildren, ReactElement } from 'react';
import { useCurrentUser } from '@mp/hooks';
import {
  isAgencyAccount,
  isSaasCredentialingOnlyAccount,
  isSaasSchedulingOnlyAccount,
} from '@mp/utils';

type SaasType = 'credentialing' | 'scheduling';

type HideFromProps = PropsWithChildren<{
  saas?: boolean;
  agency?: boolean;
  marketplace?: boolean;
  saasTypes?: SaasType[];
  fallback?: ReactElement;
}>;

export const HideFrom = ({
  saas,
  agency,
  marketplace,
  saasTypes = ['credentialing', 'scheduling'],
  children,
  fallback,
}: HideFromProps) => {
  const {
    currentUser,
    isSaas: isSaasUser,
    isAgency: isAgencyUser,
    isMarketplace,
  } = useCurrentUser();

  const isAgency = isAgencyAccount(currentUser);

  if (saas && isSaasUser) {
    if (saasTypes.length === 2) {
      return fallback ?? null;
    }
    if (saasTypes.includes('credentialing') && isSaasCredentialingOnlyAccount(currentUser)) {
      return fallback ?? null;
    }
    if (saasTypes.includes('scheduling') && isSaasSchedulingOnlyAccount(currentUser)) {
      return fallback ?? null;
    }
  }

  if (marketplace && isMarketplace) {
    return fallback ?? null;
  }

  if (agency) {
    if (isAgency || isAgencyUser) {
      return fallback ?? null;
    }
  }

  return <>{children}</>;
};
